/**
 * Usage: `@media ${minWidth.lg} { * CSS rules * }`
 */
export const minWidth = {
    sm: "(min-width: 576px)",
    md: "(min-width: 768px)",
    lg: "(min-width: 992px)",
    xl: "(min-width: 1200px)"
};

/**
 * Usage: `@media ${maxWidth.md} { * CSS rules * }`
 */
export const maxWidth = {
    sm: "(max-width: 575.98px)",
    md: "(max-width: 767.98px)",
    lg: "(max-width: 991.98px)",
    xl: "(max-width: 1199.98px)"
};
